import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import './App.css';
import Layout from "./routes/layout/Layout";
import Pricing from "./routes/pricing/Pricing";
import WhyAvopla from "./routes/why-avopla/WhyAvopla";
import Registration from "./routes/registration/Registration";
import { LanguageProvider } from "./context/LanguageContext";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children:[
        {
          path: "/",
          element: <WhyAvopla />
        },
        {
          path:"/plans",
          element:<Pricing/>
        },
        {
          path:"/registration",
          element:<Registration/>
        },
      ]
    }
  ]);

  return (
    <LanguageProvider>
      <RouterProvider router={router}/>
    </LanguageProvider>
  );
}

export default App;
